/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "StripeWebhook",
            "endpoint": "https://5x2o1w1hng.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://cywapt3rube7xmkkkzqowsvpcm.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-kgetmqwzlngflfgogrb6cxh3lu",
    "aws_cognito_identity_pool_id": "eu-central-1:f7dfead0-0e49-489f-9141-bb27fb71de84",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_oFVfi7tSu",
    "aws_user_pools_web_client_id": "5tcaholptk1v0l1ff6ugpj8j4v",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 6,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "amplify-tasty-s3-files122724-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
